// Datele din public/mydata.json (217 KB comprimat) sunt împărțite la build de
// scripts/article-data.js în fișiere mici: /data/articles/<slug>.json și
// /data/lists/<nume>.json. Paginile descarcă doar ce le trebuie.
// Dacă fișierele mici lipsesc (ex. la `npm start`), se folosește mydata.json.

const loadJson = async (url) => {
  const res = await fetch(url);
  const type = res.headers.get("content-type") || "";
  if (!res.ok || !type.includes("json")) throw new Error(`Nu există ${url}`);
  return res.json();
};

let fullDataPromise = null;
const loadFullData = () => {
  if (!fullDataPromise) fullDataPromise = loadJson("/mydata.json");
  return fullDataPromise;
};

// Lista unei categorii: "informatiiutile", "istoriesiarta", "plimbare", "distractie"
export const loadList = (name) =>
  loadJson(`/data/lists/${name}.json`).catch(() =>
    loadFullData().then((data) => data[name])
  );

// Un articol: { type: "paginiPlimbare", items: [...] } sau null dacă nu există
export const loadArticle = (slug) =>
  loadJson(`/data/articles/${encodeURIComponent(slug)}.json`).catch(() =>
    loadFullData().then((data) => {
      for (const type of Object.keys(data.paginidinamice)) {
        if (data.paginidinamice[type][slug]) {
          return { type, items: data.paginidinamice[type][slug] };
        }
      }
      return null;
    })
  );
